
import api from "../../api";

export const putProfile = async (data : any) => {

    const res : any = await api.post("member/myprofile/", data)
    return res.data
}

export const patchRegistration = async (data : {
    registration_id : string,
}) => {
    
    const res : any = await api.patch("member/myprofile/", data)
    return res.data
}

export const changeProfile = async (data : {
    bio : string,
}) => {

    const res : any = await api.put("member/myprofile/", data)
    return res.data
}

export const putBanner = async (data : {
    banner_image : File | null,
}) => {

    const formData = new FormData();
    formData.append('file', data.banner_image ?? "");

    const res : any = await api.put("member/myprofile/banner_image/", formData)
    return res.data
}

export const putProfileImage = async (data : {
    profile_image : File | null,
}) => {

    const formData = new FormData();
    formData.append('profile_image', data.profile_image ?? "");

    const res : any = await api.put("member/myprofile/profile_image/", formData)
    return res.data
}

export const getPromotions = async () => {


    const res : any = await api.get("promotions/")

    return res.data
}

export const putLocation = async (data : {
    lat : number,
    lng : number,
}) => {

    const res : any = await api.put("member/myprofile/location/", data)
    return res.data
}

export const getEventTypes = async () => {
    
    const res : any = await api.get("event_types/", {
        params : {
            page : 1,
            page_size : 100,
        }
    })
    return res.data
}